/**
 * To be used in the context of "Billed and renewed <billingFrequency>"
 */
module.exports = function () {
    return function (deliverySaverPlan) {
        if (deliverySaverPlan) {
            if (deliverySaverPlan.BillingFrequencyDays === 0) {
                switch (deliverySaverPlan.BillingFrequencyMonths) {
                    case 1: return 'monthly';
                    case 12: return 'annually';
                    default: return `every ${deliverySaverPlan.BillingFrequencyMonths} months`;
                }
            } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
                switch (deliverySaverPlan.BillingFrequencyDays) {
                    case 1: return 'daily';
                    case 7: return 'weekly';
                    default: return `every ${deliverySaverPlan.BillingFrequencyDays} days`;
                }
            }
            const months = deliverySaverPlan.BillingFrequencyMonths === 1 ? 'month' : 'months';
            const days = deliverySaverPlan.BillingFrequencyDays === 1 ? 'day' : 'days';
            return `every ${deliverySaverPlan.BillingFrequencyMonths} ${months} ${deliverySaverPlan.BillingFrequencyDays} ${days}`;
        }
        return '';
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-billing-frequency.filter.js